export default from './demo-modal';



// WEBPACK FOOTER //
// ./app/containers/demo-modal/index.js